export default __webpack_public_path__ + "static/media/aeebbb3f0bb9092b04896692bb10edbc1575981828322.b4eea184.webp";